import { __assign } from "tslib";
import classnames from 'classnames';
import React, { useContext } from 'react';
import { useDeepEqualMemo } from '@wix/da-hooks/pkg/useDeepEqualMemo';
import { ThemeOptions } from './constants';
export function getGlobalClassnamesForContext(_a) {
    var isMobile = _a.isMobile, theme = _a.theme, isSisu = _a.isSisu, _b = _a.flags, flags = _b === void 0 ? {} : _b, themeSkin = _a.themeSkin;
    return classnames(isMobile && 'mobile', !isSisu && "theme-".concat((theme || ThemeOptions.DARK).toString()), isSisu && 'sisu', themeSkin && themeSkin, flags['status_font_sizes'] && 'status_font_sizes');
}
export function getForcedGlobalClassnamesForContext(_a) {
    var theme = _a.theme;
    return "theme-".concat(theme, " forced-theme-").concat(theme);
}
export function getComponentName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// Helper to create a context provider component that instead of replacing
// parent values, it merges them with the provided ones
export function createMergingContextProvider(context, displayName) {
    if (displayName === void 0) { displayName = "".concat(context.displayName || 'Context', "Provider"); }
    var MergingContextProvider = function (_a) {
        var children = _a.children, value = _a.value;
        var parentContext = useContext(context);
        var merged = useDeepEqualMemo(__assign(__assign({}, parentContext), value));
        return React.createElement(context.Provider, { value: merged }, children);
    };
    MergingContextProvider.displayName = displayName;
    return MergingContextProvider;
}
//# sourceMappingURL=helpers.js.map